"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.themes = void 0;

var _dhig = require("./dhig2021.js");

var _themes;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var dhig2021Name = _dhig.dhig2021ObjectMeta.name;
var dhig2021DarkName = _dhig.dhig2021DarkObjectMeta.name;
var themes = (_themes = {}, _defineProperty(_themes, dhig2021Name, _dhig.getDhig2021Object), _defineProperty(_themes, dhig2021DarkName, _dhig.getDhig2021DarkObject), _themes);
exports.themes = themes;